<template>
  <div id="news_tab"
       class="main-tab main-tab-o">
    <div class="dv-content-news">
      <img src="../assets/images/icon_news_bg.png"
           class="img-news-bg">
      <div class="dv-content-s-news">
        <div class="tv-title">引领医疗科技 致力天下安康</div>
        <div class="dv-content-item-news">
          <div class="dv-left-news">
            <div class="tv-ks-title-news">新闻</div>
            <div class="ks-lists-news">
              <el-tree :data="newslistss"
                       :props="defaultProps"
                       @node-click="handleNodeClick"
                       :default-checked-keys="[1]"
                       node-key="id"
                       :current-node-key="current"
                       highlight-current></el-tree>
            </div>
          </div>
          <div class="dv-rights-news">
            <div class="tv-ks-names-news">医院新闻</div>

            <div class="dv-fwbs-news">

              <div class="dv-doctor-item-news"
                   v-for="(item,index) in newslists"
                   v-bind:key="index"
                   @mouseover="MouseOver(index)"
                   @mouseout="Mouseout()"
                   @click="onDetail(item.newsid)">
                <el-image :src="item.fileUrl"
                          fit="cover"
                          class="img-news-photo"></el-image>
                <div class="dv-news-content">
                  <div class="dv-left-list-item-content">
                    <div class="tv-news_titles"
                         :class='monindex === index ? "tv-news_titles-color" : ""'>{{ item.title }}</div>
                    <div class="tv-news_title-content">{{ item.introduce }}</div>
                    <div class="dv-news-date-ju">{{ item.createdate }}
                      <img src="../assets/images/icon_home_right.png"
                           class="img-news-right">
                    </div>
                  </div>

                </div>

              </div>

            </div>
            <div class="dv-fenye">
              <el-pagination background
                             layout="prev, pager, next"
                             prev-text="上一页"
                             next-text="下一页"
                             :page-size='showCount'
                             :total="totalResult"
                             :current-page="currentPage"
                             @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
export default {
  data () {
    return {
      current: 1,
      monindex: 10000,
      newslistss: [{
        ksname: '医院新闻',
        id: 1
      },
      {
        ksname: '医院文化',
        id: 2
      },
      {
        ksname: '患者心声',
        id: 3
      }

      ],
      defaultProps: {
        label: 'ksname',
        children: 'kschine',
      },
      newslists: [],//医院新闻列表
      showCount: 10,
      totalResult: 0,
      currentPage: 1,
    }
  },
  created () {
    if (this.$route.query.type == '1') {
      this.newslist()
      this.current = 1
    } else if (this.$route.query.type == '2') {
      this.culturelist()
      this.current = 2
    } else if (this.$route.query.type == '3') {
      this.aspirationlist()
      this.current = 3
    } else {
      this.newslist()
      this.current = 1
    }

  },
  methods: {
    MouseOver (index) {
      this.monindex = index
    },
    onDetail (id) {
      this.$router.push({
        path: '/newsDs', query: {
          id: id,
          current: this.current
        }
      })
    },
    handleNodeClick (e) {
      console.log(e)
      this.current = e.id
      this.currentPage = 1
      switch (e.id) {
        case 1:
          this.newslist()
          break;
        case 2:
          this.culturelist()
          break;
        case 3:
          this.aspirationlist()
          break;
      }

    },
    Mouseout () {
      this.monindex = 100000
    },
    handleCurrentChange (e) {
      console.log(e)
      this.currentPage = e
      switch (this.current) {
        case 1:
          this.newslist()
          break;
        case 2:
          this.culturelist()
          break;
        case 3:
          this.aspirationlist()
          break;
      }

    },
    //医院新闻列表
    newslist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.newslist(parm).then((res) => {
        this.newslists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },

    //医院文化列表
    culturelist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.culturelist(parm).then((res) => {
        this.newslists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },
    //患者心声列表
    aspirationlist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: this.currentPage,
        showCount: this.showCount,

      }
      api.aspirationlist(parm).then((res) => {
        this.newslists = res.data.list
        this.totalResult = res.data.page.totalResult
      })
    },


  }
}
</script>

<style>
.dv-content-news {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-news-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-s-news {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.tv-title {
  font-size: 28px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 100px;
  color: #ffffff;
}
.dv-content-item-news {
  width: 100%;
  /* margin-bottom: 200px; */
  height: fit-content;
  margin-top: 50px;
  min-height: 800px;
  display: flex;
  flex-direction: row;
}
.dv-left-news {
  width: 250px;
  height: 400px;
  display: flex;
  flex-direction: column;
  background: #eff2fa;
}
.tv-ks-title-news {
  font-size: 30px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  margin-left: 30px;
  margin-top: 20px;
  text-align: left;
  color: #333333;
}
.ks-lists-news {
  margin-top: 40px;
  overflow: scroll;
  padding-bottom: 40px;
}
.dv-rights-news {
  display: flex;
  width: calc(100% - 300px);
  /* background: white; */
  flex-direction: column;
  background: white;
}
.tv-ks-names-news {
  font-size: 28px;
  margin: 20px 0 0 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.dv-fwbs-news {
  width: calc(100% - 40px);
  margin-top: 20px;
  display: flex;
  flex-direction: column;
}
.dv-doctor-item-news {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-bottom: 30px;
  height: 200px;
  display: flex;
  flex-direction: row;
}
.img-news-photo {
  width: 300px;
  height: 100%;
}
.dv-news-content {
  position: relative;
  width: calc(100% - 340px);
  margin-left: 20px;
  border-bottom: 2px solid #eef0f5;
  display: flex;
  flex-direction: column;
}
.dv-left-list-item-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: 20px;
  height: 100%;
}
.tv-news_titles {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 30px;
  overflow: hidden; /* 确保内容超出容器时会被裁剪 */
  text-overflow: ellipsis; /* 使用省略号表示被裁剪的文本 */
  display: -webkit-box; /* 使用弹性盒子布局模型 */
  -webkit-line-clamp: 1; /* 限制在两行 */
  -webkit-box-orient: vertical; /* 垂直排列盒子 */
  color: #333333;
}
.tv-news_title-content {
  font-size: 19px;
  font-family: PingFang SC, PingFang SC-Semibold;
  /* font-weight: 600; */
  text-align: left;
  margin-top: 30px;
  color: #707070;
  overflow: hidden; /* 确保内容超出容器时会被裁剪 */
  text-overflow: ellipsis; /* 使用省略号表示被裁剪的文本 */
  display: -webkit-box; /* 使用弹性盒子布局模型 */
  -webkit-line-clamp: 2; /* 限制在两行 */
  -webkit-box-orient: vertical; /* 垂直排列盒子 */
}
.dv-news-date-ju {
  width: 100%;
  position: absolute;
  bottom: 20px;
  font-size: 17px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  text-align: left;
  margin-top: 30px;
  color: #707070;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.img-news-right {
  width: 24px;
  margin-top: 10px;
  /* margin-right: 30px; */
  height: 6px;
}
.tv-news_titles-color {
  color: #634d91;
  text-decoration: underline;
}
</style>